import { Link } from "@tanstack/react-router"
import { HiChevronRight } from "react-icons/hi2"
import { cn } from "~/lib/utils"

interface Props {
  text: string
  to?: string
  icon?: React.ReactNode
  right?: React.ReactNode
  className?: string
  onClick?: () => void
}

const Display = ({ text, icon, right, className, onClick }: Omit<Props, "to">) => (
  <div
    onClick={onClick}
    className={cn(
      "text-base bg-card flex items-center justify-between py-s w-full min-h-14",
      onClick && "cursor-pointer",
      className,
    )}
  >
    <div className="flex items-center gap-s min-w-0">
      {icon && <span className="shrink-0">{icon}</span>}
      {text}
    </div>
    {right === undefined ? <HiChevronRight className="shrink-0 text-muted-foreground" /> : right}
  </div>
)

export const SettingsItem = ({ to, ...props }: Props) => {
  if (to) return <Link to={to}><Display {...props} /></Link>
  return <Display {...props} />
}
